export const BaseUrl = 'https://codekrafters.co.in/admin/api';
export const WebUrl = 'https://codekrafters.co.in/admin/storage/app/public';
export const ImageURL = 'https://codekrafters.co.in/admin/storage/app/public';
// export const BaseUrl = 'http://localhost:8000/api';
// export const WebUrl = 'http://localhost:8000/storage';   